import $ from 'jquery';

/**
 *
 * @param {Array} comments
 * @return {PageCommentsViewModel}
 */
export function init(comments) {
	let model = new PageCommentsViewModel(comments);

    ko.applyBindings(model, $('#page_comments_wrapper')[0]);
    model.postInit();

    return model;
}

class PageCommentsViewModel {
    _$wrapper = $('#page_comments_wrapper');
    _scroll = null;
    comments = null;

    constructor(comments) {
        this.comments = new ko.observableArray(comments);
        this._scroll = this._$wrapper.zInfiniteScroll(
            {
                selector: '.comment',
                checkViewport: false,
                enabled: true,
                autoStart: false,
                maxAutoloadPages: 100,
                loading: '#page_comments_scroll_loader',
                fetch: (page, callback) => {
                    $.get(
                        this._$wrapper.data('load-url'),
                        {
                            page: page,
                            blog_page_id: this._$wrapper.data('page-id'),
                            raw: 1
                        },
                        (response) => {
                            callback(response.comments);
                        },
                        'json'
                    );
                },
                show: (items) => {
                    for(let i = 0; i < items.length; i++) {
                        this.comments.push(items[i]);
                    }

                    return items.length;
                }
            }
        );
    }

    afterRender(elements, data) {
        $(elements).find('.comment-text-container').urlconverter(30);
        $(document).trigger('heightTargetUpdated');
    };

    postInit() {
        this._scroll.on();
    }
}



// WEBPACK FOOTER //
// ./modules/blog/pagecomments/pagecomments.js